// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__GPjwc","shake":"FloatingButton_shake__qivDX"};